import type { Block, BlockType, Section } from '@/api/courses';

/**
 * Черновик конструктора → разделы в том виде, в каком их рисует ученику плеер.
 *
 * ⚠️ БЕРЁТСЯ ЧЕРНОВИК, А НЕ СОХРАНЁННЫЙ УРОК. Методист жмёт «Как у ученика», чтобы
 * проверить только что сделанную правку; показать ему версию с сервера двухсекундной
 * давности значило бы показать не то, что он проверяет.
 *
 * Порядок — позиция в массиве черновика (так же считает сохранение), id — те же, что
 * в черновике: по ним кнопка «Редактировать» возвращает к нужному блоку.
 */

type DraftBlockLike = { id: string; type: BlockType; content: Record<string, unknown> };
type DraftSectionLike = { id: string; title: string; is_homework?: boolean; blocks: DraftBlockLike[] };

export function toPreviewSections(drafts: DraftSectionLike[], lessonId: string | undefined): Section[] {
  return drafts.map((s, i) => ({
    id: s.id,
    lesson_id: lessonId ?? '',
    title: s.title,
    order_index: i,
    is_homework: s.is_homework ?? false,
    blocks: s.blocks.map(
      (b, j): Block => ({ id: b.id, section_id: s.id, type: b.type, content: b.content, order_index: j }),
    ),
  }));
}
